import { WorkflowTriggerTypes } from 'src/app/models/RestApiCaller/Enums/workflow-trigger-types';
import { BaseTriggerData } from './base-trigger-data';

/**
 * Représente les données d'un trigger 'Finalisation de l'étape'.
 */
export class StepCompletedTriggerData extends BaseTriggerData {
    /// <summary>
    /// Id de l'étape completée.
    /// </summary>
    public stepId: number = null;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowTriggerTypes.StepCompleted);
    }

    /**
     * Retourne une copie d'une instance de StepCompletedTriggerData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: StepCompletedTriggerData) {
        if (!!other) {
            const instance = new StepCompletedTriggerData();
            instance.stepId = other.stepId;
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
